import { PromiseUtils } from '@/shared/util/promise-utils'
import { store } from '@/store/store'
import { shipmentsRequestFiltererService } from '@/modules/shipments-module/services/request/request-filterer/shipments-request-filterer.service'
import { shipmentsItemFinderService } from '@/modules/shipments-module/services/item/item-finder/shipments-item-finder.service'
import { ShipmentsStoreHelper } from '@/modules/shipments-module/store/shipments-store.helper'

export class ShipmentsUtil {
    static async loadSummaries(): Promise<void> {
        ShipmentsStoreHelper.summaries = {
            shipmentsPendingToSend:
                await PromiseUtils.toCallSecure(
                    shipmentsRequestFiltererService.getPendingToBeSendSummary(store.state.labId)) ?? 0,
            shipmentsPendingToReceive:
                await PromiseUtils.toCallSecure(
                    shipmentsItemFinderService.getPendingToBeReceivedSummary(store.state.labId)) ?? 0
        }
    }
}
